const mixins = {
    methods: {

    }
};

export default mixins;